import { Subject } from 'rxjs';

/**
 * Model for a loading screen that displays a progress bar.
 *
 * If no progress is set, the bar is completely filled and animated. If a progress is given, it is displayed
 * both using a partially filled progress bar and a percentage written on the progress bar.
 *
 * @format
 */

export class LoadingScreenModel {
    public percent: number;
    public usePercent = false;

    public readonly loadingScreenDisplayed$: Subject<boolean>;
    public constructor(
        public message: string,
        public doneAction?: () => void,
    ) {
        this.loadingScreenDisplayed$ = new Subject<boolean>();
    }

    /**
     * Update the percentage of the progress. Range is 0-100.
     *
     * @param percent
     */
    public progressUpdate(percent: number): void {
        this.usePercent = true;
        this.percent = percent;
        const maximumPercent = 100;
        if (percent >= maximumPercent && this.doneAction) {
            this.doneAction();
        }
    }

    public triggerViewRendered(): void {
        // We need to make sure that the modal actually is drawn on the screen before anybody calls hide() on it;
        // otherwise the hide call will be ignored and the modal will be displayed indefinitely on the screen.
        // See also https://github.com/valor-software/ngx-bootstrap/pull/4550
        const moreThanHalfASecond = 600;
        setTimeout(() => {
            this.loadingScreenDisplayed$.next(true);
            this.loadingScreenDisplayed$.complete();
        }, moreThanHalfASecond);
    }
}
